var attended_course_archive = (function( $ ) {

	var brand_pink = '#ec6471';

	var grey_1 = '#c7c9c7';

	var $filters;

	var _init = function() {
		if ( $( '.attended-course-header .filter' ).length > 0 ) {
			$filters = $( '.filters-wrapper' );

			$filters.find( '.header' ).on( 'click', _toggle_filters );
		}
	};

	var _toggle_filters = function( e ) {
		e.preventDefault();

		var $group = $( this ).closest( '.filter-group' );

		var $groups = $filters.find( '.filter-group' ).not( $group );

		$groups.each( function() {
			if ( $( this ).hasClass( 'open' ) ) {
				_close_filters( $( this ) );
			}
		} );

		if ( $group.hasClass( 'open' ) ) {
			_close_filters( $group );
		} else {
			_open_filters( $group );
		}
	};

	var _close_filters = function( $group ) {
		var width = $group.find( '.header' ).outerWidth();
		var height = $group.find( '.header' ).outerHeight();

		var $border = $group.find( '.header .border' );

		$group.addClass( 'closing' );
		$group.removeClass( 'open' );
		$group.find( '.filters' ).slideUp();

		$border.css( {
			'border-width': '5px',
			width:          width,
			height:         height
		} );

		setTimeout( function() {
			$group.find( '.header' ).css( {
				'border-color': grey_1
			} );

			$border.css( {
				top:    '-2px',
				width:  0,
				height: 0
			} );

			setTimeout( function() {
				$border.css( {
					opacity: 0
				} );

				$group.removeClass( 'closing' );
			}, 400 );

		}, 400 );
	};

	var _open_filters = function( $group ) {
		var width = $group.find( '.header' ).outerWidth();
		var height = $group.find( '.header' ).outerHeight();

		var $border = $group.find( '.header .border' );

		$border.css( {
			opacity: 1,
			width:   width,
			height:  height
		} );

		setTimeout( function() {
			$group.addClass( 'open' );
			$group.find( '.filters' ).slideDown();

			$group.find( '.header' ).css( {
				'border-color': brand_pink
			} );

			$border.css( {
				'border-width': '4px',
				top:            0,
				width:          '100%',
				height:         '100%'
			} );
		}, 400 );
	};

	if ( $( 'body.post-type-archive-attended_course' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = attended_course_archive;